import { Link } from '@tanstack/react-router'
import { GlassButton } from '@/components/ui/GlassButton'
import { GlassCard } from '@/components/ui/GlassCard'
import { ArrowRight } from 'lucide-react'
import config from '@config'
import { useT } from '@/i18n/provider'

export function CTASection() {
  const t = useT()

  return (
    <section className="relative z-10 py-24 px-6">
      <div className="max-w-3xl mx-auto">
        <GlassCard glow className="text-center space-y-6 py-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            {t('landing.cta.title')}
          </h2>
          <p className="text-white/55 max-w-lg mx-auto">
            {t('landing.cta.subtitle')}
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link to="/auth/register">
              <GlassButton size="lg" variant="primary" className="gap-2">
                {t('landing.cta.button')}
                <ArrowRight size={16} />
              </GlassButton>
            </Link>
          </div>
          <p className="text-xs text-white/25">
            {t('landing.cta.meta')}
          </p>
        </GlassCard>
      </div>

      {/* Footer */}
      <footer className="mt-16 text-center text-xs text-white/20 space-y-2">
        <p>{config.app.name} · {config.app.tagline}</p>
        <p>
          {t('landing.cta.builtOn')}{' '}
          <a
            href="https://openclaw.ai"
            target="_blank"
            rel="noreferrer"
            className="hover:text-white/40 underline underline-offset-2"
          >
            openclaw.ai
          </a>
        </p>
      </footer>
    </section>
  )
}
